import React from 'react';
import { defineMessages } from 'react-intl-next';

import { MiniSectionMessage } from '../UpsellLooknFeel/MiniSectionMessage.tsx';
import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery.ts';

export const i18n = defineMessages({
	body: {
		id: 'change-edition.inline-message.share-and-restrict-dialog.body',
		defaultMessage: 'You can restrict this content to specific people on paid plans.',
		description:
			'The text is shown as the inline upsell body message inside the share and restrict dialog when a user on the free plan views the content restriction controls. It informs them that restricting content to specific people is only available on paid plans and encourages upgrading. There are no placeholders in this message. Explains the limitation and upsell.',
	},
	learnMoreLink: {
		id: 'change-edition.inline-message.share-and-restrict-dialog.learn-more-link',
		defaultMessage: 'Learn more',
		description:
			'The text is shown as the hyperlink label within the inline upsell message in the share and restrict dialog when a user on the free plan sees the restrictions upsell. It takes them to a documentation page that explains page-level permissions and restrictions in more detail. There are no placeholders in this message. Explains the navigation action to learn about restrictions.',
	},
});

const SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';

export const ChangeEditionInlineMessageShareAndRestrict = ({
	source,
	customPadding,
	href = SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION,
}: {
	source: string;
	customPadding?: string;
	href?: string;
}) => {
	const learnMoreLink = {
		href,
		actionSubjectId: source,
		messageDescriptor: i18n.learnMoreLink,
	};

	return (
		<MiniSectionMessage
			source={source}
			messageContent={i18n.body}
			withGradient={false}
			customPadding={customPadding}
			learnMoreLink={learnMoreLink}
			targetEdition={ConfluenceEdition.STANDARD}
		/>
	);
};
